// The words under a Figma link field and in the share guide. One copy for Figmafolio and Aero, so
// the two brands never say different things. Aero's tone rules apply to both: plain words, no
// exclamation marks, no em dashes, British spelling, sentence case.
export const NOTE_COPY = {
  converted: 'Changed to a prototype link.',
  checking: 'Checking that anyone can open it',
  viewable: 'Anyone with the link can open this prototype',
  notViewable: {
    head: "Visitors can't open this prototype yet.",
    body: "It isn't shared with everyone, or the link is wrong. Visitors would see a Figma error instead of your site.",
    show: 'Show me how',
    again: 'Check again',
  },
  notFigma: {
    head: "That doesn't look like a Figma link.",
    body: 'Paste a prototype link. It starts with figma.com/proto/.',
  },
  unsupported: {
    head: "That isn't a prototype link.",
    body: "Sites need a prototype from a Figma Design file. Boards, Make and slides don't work.",
  },
};

export const GUIDE_COPY = {
  title: 'Share your prototype with everyone',
  steps: [
    ['1. Open Share, then the access row', 'In Figma, click Share (it says Share prototype in presentation view). Then click the row that says who can open it.'],
    ['2. Choose Anyone, then View', 'Set Who can access to Anyone and What can they do to View. Save.'],
    ['3. Save, then come back here', "You don't need to copy anything. This checks again by itself."],
  ],
  footer: "No access options in that window? Close it, open the file, click Share and set it there. No Anyone option at all? Your Figma admin may have turned off public links.",
  doneTitle: "It's shared.",
  doneSub: 'Visitors can open this prototype.',
  toast: 'Now shared',
};
